module.exports = __webpack_public_path__ + "img/SocketIO.4cb9ecf1.png";